type NullableStringKeys<T> = {
	[K in keyof T]: T[K] extends string | null ? K : never
}[keyof T]

// Тип для значения замены
type ReplaceValue = '' | undefined

// Тип для обновленного объекта
type UpdatedObject<T, K extends NullableStringKeys<T>, R extends ReplaceValue> = {
	[P in keyof T]: P extends K ? (R extends undefined ? string | undefined : string) : T[P]
}

export function replaceNullWithValue<T, K extends NullableStringKeys<T>, R extends ReplaceValue>(obj: T, fields: K[], replaceValue: R): UpdatedObject<T, K, R> {
	const result = { ...obj }
	fields.forEach((field) => {
		if (result[field] === null) {
			;(result[field] as any) = replaceValue
		}
	})
	return result as UpdatedObject<T, K, R>
}
